import axios from "axios";
import { authHeaderJson, authHeaderTextPlain } from "../auth-header.service";

const getListMasterKpis = () => {
    return axios.get(`/api/SkKpi/masterkpi/list`, { headers: authHeaderJson() } )
};

const getMasterKpiById = (masterkpiId) => {
        return axios.get(`/api/SkKpi/masterkpi/${masterkpiId}`, { headers: authHeaderJson() } );
};

const addMasterKpi = (masterkpi) => {
    return axios.post(`/api/SkKpi/masterkpi/add/`, masterkpi, { headers: authHeaderJson() } );
}

const addMasterKpiList = (masterkpis) => {
    return axios.post(`/api/SkKpi/masterkpi/add/list`, masterkpis, { headers: authHeaderJson() } );
}

const saveMasterKpiById = (masterkpiId, objContract) => {
    return axios.put(`/api/SkKpi/masterkpi/${masterkpiId}`, objContract, { headers: authHeaderJson() });
};

const deleteMasterKpi = (masterkpiId) => {
    return axios.delete(`/api/SkKpi/masterkpi/${masterkpiId}`, { headers: authHeaderTextPlain() });
}

export {
    getListMasterKpis,
    getMasterKpiById,
    addMasterKpi,
    addMasterKpiList,
    saveMasterKpiById,
    deleteMasterKpi
}